module.exports = __webpack_public_path__ + "img/oficina-quito.b45f9cae.jpg";